export const SentMessageAnimation = require('./MessageSent-Animation.json');
export const ScheduleMessageAnimation = require('./ScheduleMessage-Animation.json');
export const LoaderAnimation = require('./Loader-Animation.json');
